import { CreateCallOutcomeParams, UpdateCallOutcomeParams } from '../models'

// Payload builder for spLutCampaignCallOutcomesCreate. PartnerId and LocationId
// are independent identifiers — send each only when known, so a record keyed by
// one kind never carries an empty value for the other. The backend picks the
// authoritative identifier from whichever is present.
export const buildCallOutcomeCreateParams = ({
  campaignId,
  isr,
  callingListId,
  partnerId,
  locationId,
}: CreateCallOutcomeParams) => ({
  'p.CampaignId': campaignId,
  'p.ISR': isr,
  'p.CallingListId': callingListId,
  ...(partnerId !== undefined && { 'p.PartnerId': partnerId }),
  ...(locationId !== undefined && { 'p.LocationId': locationId }),
})

export const buildCallOutcomeUpdateParams = ({ callOutcome }: UpdateCallOutcomeParams) => ({
  'p.EntryId': callOutcome.entryId,
  'p.CallStatus': callOutcome.callStatus,
  'p.CallAction': callOutcome.callAction,
  'p.CallDate': callOutcome.callDate,
  'p.CallFeedback': callOutcome.callFeedback,
  'p.IsOpportunityIdentified': callOutcome.isOpportunityIdentified,
  'p.IsCallBack': callOutcome.isCallBack,
})
